import moment from "moment-timezone";

const DateTime = ({ timestamp }) =>
  moment(timestamp).tz("America/New_York").format("MMM D, YYYY h:mm A");

export default DateTime;
